// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3jtyX","badges":"styles_badges__3UMH1"};